enum AcomodacaoSolicitacaoEnum {
  Apartamento = 'Apartamento',
  Enfermaria = 'Enfermaria',
}

export default AcomodacaoSolicitacaoEnum
